import { render, staticRenderFns } from "./ProductFeedbackProductDetails.vue?vue&type=template&id=359f2cea&"
import script from "./ProductFeedbackProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductFeedbackProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports